module.exports = __webpack_public_path__ + "img/download-white.c8143667.svg";